module.exports = __webpack_public_path__ + "img/home.bab0cd1e.png";